import { useParams, Navigate } from "react-router-dom";
import { findCity } from "@/constants/cities";
import { PHONE_DISPLAY } from "@/constants/content";
import { Seo } from "@/components/Seo";
import { Hero } from "@/components/Hero";
import { StepsStrip } from "@/components/StepsStrip";
import { Editorial } from "@/components/Editorial";
import { WhatWeAccept } from "@/components/WhatWeAccept";
import { HowItWorks } from "@/components/HowItWorks";
import { Marquee } from "@/components/Marquee";
import { Testimonials } from "@/components/Testimonials";
import { ServiceAreas } from "@/components/ServiceAreas";
import { Faq } from "@/components/Faq";

export default function CityPage() {
    const { slug } = useParams();
    const city = findCity(slug);

    if (!city) return <Navigate to="/" replace />;

    return (
        <main>
            <Seo
                title={`Cash for Cars ${city.name} | Toronto Scrap Car Removal`}
                description={`Cash for cars in ${city.name}: top cash paid on the spot, free same-day flatbed towing across ${city.name} & the GTA. Call ${PHONE_DISPLAY} for an instant offer.`}
            />
            <Hero city={city} />
            <StepsStrip />
            <Editorial cityName={city.name} />
            <WhatWeAccept />
            <HowItWorks />
            <Marquee />
            <Testimonials />
            <ServiceAreas />
            <Faq />
        </main>
    );
}
